import React from 'react';
import { Col, Row } from 'antd';
import { translate } from '@portal/services/i18n';
import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import './ErrorFallback.less';

type ErrorFallbackProps = {
  error: unknown;
  componentStack?: string;
  resetError?: () => void;
};

const ErrorFallback = ({ resetError }: ErrorFallbackProps) => {
  return (
    <div className="error-fallback">
      <Row
        justify="center"
        align="middle"
        className="error-fallback__container"
      >
        <Col xs={24} sm={20} md={16} lg={12} xl={8}>
          <div className="error-fallback__content">
            <h1 className="error-fallback__title">
              {translate('APPLICATION.ERRORS.UNEXPECTED_ERROR')}
            </h1>
            {resetError ? (
              <AdvancedButton
                text={translate('APPLICATION.ERRORS.RELOAD_PAGE')}
                onClick={resetError}
              />
            ) : null}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ErrorFallback;
